export default function progressionDashboardData(data) {
	return {
		progress: data.user.progressionData.progress,
		doneDate: (data.user.progressionData.doneTimestamp ? new Date(data.user.progressionData.doneTimestamp) : null),
	}
}